module.exports = __webpack_public_path__ + "img/2-1_Graph_Select.a800efff.png";